<pbc-sorter [config]="TemplatesSorterConfig" [sorter]="templates.sorter$ | async" (sorterChange)="templates.sorter$.next($event)"></pbc-sorter>
